import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import { Translation } from '../../contexts/TranslationContext'
import type { FooterResult } from '../../data/FooterFragment'
import { useForceOpenCookieBar } from '../shared/CookieProvider'
import style from './Footer.module.sass'

type FooterPathProps = {
	aloneStanding?: boolean
	footer: FooterResult
}

export const FooterPath: FunctionComponent<FooterPathProps> = ({ aloneStanding = false, footer }) => {
	const actualYear = new Date().getFullYear()
	const forceOpenCookieBar = useForceOpenCookieBar()

	return (
		<div className={clsx(style.copyright, aloneStanding && style.copyrightAloneStanding)}>
			{footer.copyright && (
				<span className={style.copyrightText}>
					&copy; {actualYear} {footer.copyright}
				</span>
			)}
			<span className={style.linkGroup}>
				{footer.items?.map(
					(item) =>
						item.link && (
							<a
								href={item.link}
								key={item.link}
								title={item.label}
								className={style.link}
								rel="noreferrer"
								target={item.targetBlank ? '_blank' : ''}
							>
								{item.label}
							</a>
						),
				)}
				<button className={clsx(style.cookiesButton, style.link)} onClick={forceOpenCookieBar}>
					<Translation tr="footer.cookies" />
				</button>
			</span>
		</div>
	)
}
